import { Chip, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { OrderStatus } from 'common/model/OrderStatus';
import { OrderStatusColor } from 'common/model/StatusColor';
import { timeBetween } from 'common/utils/helper';
import { t } from 'i18next';
import {
  noteTooltipStyles,
  noteChipStyles,
  noteChipEmptyStyles,
} from './OrderList.styles';

export const orderListColumns: GridColDef[] = [
  {
    field: 'price',
    headerName: 'Fiyat',
    width: 70,
    renderCell: (params) => {
      return <>{params.row?.price} TL</>;
    },
  },
  {
    field: 'paymentMethod',
    headerName: 'Ödeme Yöntemi',
    width: 140,
    renderCell: (params) => {
      return <b>{t('paymentMethods.' + params.row?.paymentMethod)}</b>;
    },
  },
  {
    field: 'address',
    headerName: 'Adres',
    renderCell: (params) => {
      const address = params.row?.address;
      return <>{address?.address}</>;
    },
    width: 200,
  },
  {
    field: 'createdAt',
    headerName: 'Sipariş Tarihi',
    width: 130,
    renderCell: (params) => {
      return <>{timeBetween(params.row?.createdAt)}</>;
    },
  },
  {
    field: 'basket',
    headerName: 'Sepet',
    renderCell: (params) => {
      const basket = params.row.basket;
      return <>{basket.length} Ürün</>;
    },
    width: 150,
  },
  {
    field: 'note',
    headerName: 'Not',
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      const hasNote = params.row.note && params.row.note.trim() !== '';
      return (
        <Tooltip
          title={params.row.note}
          placement="top"
          arrow
          componentsProps={{
            tooltip: {
              sx: noteTooltipStyles,
            },
          }}
        >
          <Chip
            label={hasNote ? 'VAR' : 'YOK'}
            size="small"
            color={hasNote ? 'warning' : 'default'}
            variant={hasNote ? 'filled' : 'outlined'}
            sx={{
              ...noteChipStyles,
              ...(hasNote ? {} : noteChipEmptyStyles),
            }}
          />
        </Tooltip>
      );
    },
    width: 100,
  },
  {
    field: 'status',
    headerName: 'Durum',
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => orderStatusDot(params.row?.status),
    width: 80,
  },
];

export const orderStatusDot = (status: OrderStatus) => (
  <Chip
    sx={
      status === OrderStatus.DELIVERED || status === OrderStatus.REJECTED
        ? {
            height: 10,
            width: 10,
          }
        : { height: 18, width: 18 }
    }
    color={
      OrderStatusColor[status.toUpperCase() as keyof typeof OrderStatusColor]
    }
  />
);
